import React from 'react';
import PropTypes from 'prop-types';
import ProjectBanner from './ProjectBanner';
import EventBanner from './EventBanner';
import OfferBanner from './OfferBanner';
import RedirectBanner from './RedirectBanner';

Banner.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  project: PropTypes.shape({
    id: PropTypes.number
  }),
  event: PropTypes.shape({
    id: PropTypes.number
  }),
  offer: PropTypes.shape({
    id: PropTypes.number
  }),
  onClose: PropTypes.func
};

export default function Banner(props) {
  const {
    user,
    project,
    event,
    offer,
    onClose
  } = props;

  if (project) {
    return (
      <ProjectBanner
        user={user}
        project={project}
        onClose={onClose}
      />
    );
  }

  if (event) {
    return (
      <EventBanner
        user={user}
        event={event}
      />
    );
  }

  if (offer) {
    return (
      <OfferBanner
        user={user}
        offer={offer}
        onClose={onClose}
      />
    );
  }

  return (
    <RedirectBanner
      user={user}
      onClose={onClose}
    />
  );
}
